import { useWeb3React } from "@web3-react/core";
import millify from "millify";
import { useEffect, useState } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom"; //page
import Web3 from "web3";
import Navbar from "../components/Navbar/Navbar.jsx";
import ClaimToken from "../pages/ClaimToken/ClaimToken.jsx";
import Create from "../pages/Create/Create.jsx";
import Home from "../pages/Home/index.js";

export default function Router() {
  const web3context = useWeb3React();
  const { active, account, library, connector, activate, deactivate, chainId } =
  useWeb3React();
  const [userBalance, setUserBalance] = useState("");
  const [triggerTransaction, setTriggerTransaction] = useState(false);

  useEffect(async () => {
    if (account && active) {
      const web3 = new Web3(library?.currentProvider);
      let account = await web3.eth.getAccounts();
      web3.eth.getBalance(account[0].toLowerCase()).then((balance) => {
        setUserBalance(
          millify(web3.utils.fromWei(balance, "ether"), {
            precision: 4,
            lowercase: false,
          })
        );
      });
    }
  }, [account, chainId, triggerTransaction]);
  return (
    <div>
      <Navbar userBalance={userBalance}/>
      <Routes>
        <Route path="/" exact element={<Home setTriggerTransaction={setTriggerTransaction} triggerTransaction={triggerTransaction} />} />
        {/* <Route path="/claim" exact element={<ClaimToken />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
